import {
	Button,
	Card,
	CardContent,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Grid,
	makeStyles,
	TextField,
	Typography,
} from "@material-ui/core";
import React from "react";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useHistory } from "react-router";
import { axiosReq } from "../utils/functions";
import { useDispatch } from "react-redux";
import { setLoadingPage } from "../redux/items/PageLoading";
import { resetBookingList, setBookingList } from "../redux/items/BookingList";

const useStyles = makeStyles({
	card: {
		marginTop: 32,
		marginBottom: 0,

		border: "0.5px solid #C4C4C4",
		boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
		borderRadius: 21,
	},
});

const ChooseBetCheck = observer(() => {
	const hist = useHistory();
	const v = useLocalObservable(() => ({
		bookingNo: "",
		otp: "",
		otpError: "",
		openOtp: false,

		country_code: "+65",
		mobileNumber: "",
		mobileError: "",
	}));
	const classes = useStyles();
	const dispatch = useDispatch();

	React.useEffect(() => {
		dispatch(resetBookingList());
		// eslint-disable-next-line
	}, []);

	return (
		<MainContainer
			render={
				<Grid
					container
					style={{
						// backgroundColor: "red",
						alignItems: "center",
						height: 100,
					}}
				>
					<Grid item xs={12}>
						<TopBar leftSide="/" title="Check Bet" />
					</Grid>
				</Grid>
			}
		>
			<div
				style={{
					//backgroundColor: "red",
					padding: "50px 16px",
				}}
			>
				{/* <Card className={classes.card}>
					<CardContent
						style={{ display: "flex", flexDirection: "column" }}
					>
						<Typography variant="h5" style={{ marginBottom: 16 }}>
							Check by Booking No
						</Typography>
						<TextField
							placeholder="Booking No"
							style={{ marginBottom: 16 }}
							value={v.bookingNo}
							onChange={(e) => (v.bookingNo = e.target.value)}
						/>
						<div>
							<Button
								onClick={() => {
									let tmpBookingNo = v.bookingNo.trim();
									if (tmpBookingNo !== "") {
										hist.push("/check/" + tmpBookingNo);
									}
								}}
							>
								Submit
							</Button>
						</div>
					</CardContent>
				</Card> */}

				<Card className={classes.card}>
					<form
						onSubmit={async (e) => {
							e.preventDefault();
							v.mobileError = "";
							dispatch(setLoadingPage(true));

							let paramsMobileNumber = v.mobileNumber.trim();

							let ret = await axiosReq(
								"booking-check-mobile-number",
								{
									mobileNumber:
										v.country_code +
										"" +
										paramsMobileNumber,
								}
							);
							// console.log(ret);
							if (ret.status === "success") {
								v.openOtp = true;
							} else {
								v.mobileError = ret.message;
							}
							dispatch(setLoadingPage(false));
						}}
					>
						<CardContent
							style={{ display: "flex", flexDirection: "column" }}
						>
							<Typography
								variant="h5"
								style={{ marginBottom: 16 }}
							>
								Check by Mobile Number
							</Typography>
							<Grid container spacing={1}>
								<Grid item xs={2}>
									<TextField
										placeholder="Mobile Number"
										style={{ marginBottom: 16 }}
										value={v.country_code}
										onChange={(e) => {
											v.country_code = e.target.value;
										}}
										fullWidth={true}
									/>
								</Grid>
								<Grid item xs={10}>
									<TextField
										placeholder="Mobile Number"
										style={{ marginBottom: 16 }}
										value={v.mobileNumber}
										onChange={(e) => {
											v.mobileNumber = e.target.value;
										}}
										fullWidth={true}
									/>
								</Grid>
							</Grid>
							<div
								dangerouslySetInnerHTML={{
									__html: v.mobileError,
								}}
								style={{ color: "red", textAlign: "center" }}
							/>
							<div>
								<Button type="submit">Submit</Button>
							</div>
						</CardContent>
					</form>
				</Card>

				<Card className={classes.card}>
					<CardContent>
						<Typography variant="h5" style={{ marginBottom: 16 }}>
							Check Booking used in this Device
						</Typography>
						<Grid container justify="center">
							<Button
								onClick={() => hist.push("/booking-list/1")}
							>
								Check
							</Button>
						</Grid>
					</CardContent>
				</Card>
			</div>
			<Dialog
				open={v.openOtp}
				onClose={() => (v.openOtp = false)}
				maxWidth="xs"
			>
				<form
					onSubmit={async (e) => {
						e.preventDefault();
						v.otpError = "";
						dispatch(setLoadingPage(true));

						let ret = await axiosReq("booking-check-otp", {
							mobileNumber: v.country_code + "" + v.mobileNumber,
							otp: v.otp,
						});

						// console.log(ret);
						if (ret.status === "success") {
							dispatch(setBookingList(ret.data));
							hist.push("booking-list");
						} else {
							v.otpError = ret.message;
						}
						dispatch(setLoadingPage(false));
					}}
				>
					<DialogTitle>Key In OTP</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<TextField
								variant="outlined"
								fullWidth={1}
								placeholder="OTP"
								value={v.otp}
								onChange={(e) => {
									v.otp = e.target.value;
								}}
							/>
							<div
								dangerouslySetInnerHTML={{
									__html: v.otpError,
								}}
								style={{ color: "red", textAlign: "center" }}
							/>
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button type="submit">Submit</Button>
					</DialogActions>
				</form>
			</Dialog>
		</MainContainer>
	);
});

export default ChooseBetCheck;
